import { Component, OnInit, inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { DatePipe } from '@angular/common';
import { PageTitleService } from '../../core/services/page-title.service';
import { DownloadService } from '../../core/services/download.service';

@Component({
    selector: 'app-download',
    imports: [FormsModule, DatePipe],
    template: `
<div class="animated fadeIn container-fluid">
  <div class="card">
    <div class="card-header">
      <span><i class="fa s-icon-list"></i> 一覧 <span>(全 {{items.length}} 件)</span></span>
    </div>
    <div class="card-body">
      <div class="row">
        <div class="col-md-12"><div style="height: 1px"></div></div>
      </div>
    </div>
    <div class="card-body">
      <div class="form-group row">
        <div class="col-md-12">
          <button class="btn btn-outline-primary" type="button" (click)="loadList()" [disabled]="isDisabled">
            <span class="material-symbols-outlined align-bottom">sync</span>&nbsp;更新
          </button>
        </div>
      </div>
      <ul class="pagination pull-right">
        @if (shouldShowPager) {
          <li class="page-item" [class.disabled]="showStart === 0">
            <a class="page-link" href="" aria-label="Previous" (click)="pagerClick(0, $event)">
              <span aria-hidden="true">&laquo;</span>
              <span class="sr-only">Previous</span>
            </a>
          </li>
          <li class="page-item" [class.disabled]="currentPage === 0">
            <a class="page-link" href="" aria-label="Previous" (click)="pagerClick(currentPage - 1, $event)">
              <span aria-hidden="true">prev</span>
              <span class="sr-only">Previous</span>
            </a>
          </li>
        }
        @for (pager of pagerArr(); track pager) {
          @if (pager >= showStart && pager <= showEnd) {
            <li class="page-item" [class.active]="pager === currentPage">
              <a href="" class="pager-item page-link" (click)="pagerClick(pager, $event)">{{ pager + 1 }}</a>
            </li>
          }
        }
        @if (shouldShowPager) {
          <li class="page-item" [class.disabled]="currentPage >= totalPages - 1">
            <a class="page-link" href="" aria-label="Next" (click)="pagerClick(currentPage + 1, $event)">
              <span aria-hidden="true">next</span>
              <span class="sr-only">Next</span>
            </a>
          </li>
          <li class="page-item" [class.disabled]="showEnd >= totalPages - 1">
            <a class="page-link" href="" aria-label="Next" (click)="pagerClick(totalPages - 1, $event)">
              <span aria-hidden="true">&raquo;</span>
              <span class="sr-only">Next</span>
            </a>
          </li>
        }
      </ul>
      @if (items.length === 0) {
        <span>該当するデータはありません</span>
      }
      @if (items.length > 0) {
        <table class="table table-bordered table-hover table-ptb-0">
          <thead>
            <tr>
              <th width="10%">結果</th>
              <th width="15%">対象店舗</th>
              <th>ファイル名</th>
              <th width="20%">作成日時</th>
              <th width="10%"> </th>
            </tr>
          </thead>
          <tbody>
            @for (item of pagedItems; track item.id) {
              <tr>
                <td class="text-center">
                  @if (+item.status === 0) { <span>作成中</span> }
                  @if (+item.status === 1) { <span>成功</span> }
                  @if (+item.status === 2) { <span>失敗</span> }
                </td>
                <td>{{item.studio ? item.studio.name : '全店'}}</td>
                <td>{{item.name || item.fileName}}</td>
                <td><span>{{+item.status === 1 ? (item.updatedAt | date:'yyyy/MM/dd HH:mm:ss') : '-'}}</span></td>
                <td class="text-center">
                  @if (+item.status === 1) {
                    <button type="button" class="mt-1 mb-1 btn btn-primary btn-sm text-white" (click)="downloadFile(item)" title="ダウンロード">
                      <span class="material-icons-outlined align-bottom">download</span>
                    </button>
                  }
                </td>
              </tr>
            }
          </tbody>
        </table>
        <ul class="pagination pull-right">
          @if (shouldShowPager) {
            <li class="page-item" [class.disabled]="showStart === 0">
              <a class="page-link" href="" aria-label="Previous" (click)="pagerClick(0, $event)">
                <span aria-hidden="true">&laquo;</span>
                <span class="sr-only">Previous</span>
              </a>
            </li>
            <li class="page-item" [class.disabled]="currentPage === 0">
              <a class="page-link" href="" aria-label="Previous" (click)="pagerClick(currentPage - 1, $event)">
                <span aria-hidden="true">prev</span>
                <span class="sr-only">Previous</span>
              </a>
            </li>
          }
          @for (pager of pagerArr(); track pager) {
            @if (pager >= showStart && pager <= showEnd) {
              <li class="page-item" [class.active]="pager === currentPage">
                <a href="" class="pager-item page-link" (click)="pagerClick(pager, $event)">{{ pager + 1 }}</a>
              </li>
            }
          }
          @if (shouldShowPager) {
            <li class="page-item" [class.disabled]="currentPage >= totalPages - 1">
              <a class="page-link" href="" aria-label="Next" (click)="pagerClick(currentPage + 1, $event)">
                <span aria-hidden="true">next</span>
                <span class="sr-only">Next</span>
              </a>
            </li>
            <li class="page-item" [class.disabled]="showEnd >= totalPages - 1">
              <a class="page-link" href="" aria-label="Next" (click)="pagerClick(totalPages - 1, $event)">
                <span aria-hidden="true">&raquo;</span>
                <span class="sr-only">Next</span>
              </a>
            </li>
          }
        </ul>
      }
    </div>
  </div>
</div>
  `
})
export class DownloadComponent implements OnInit {
  private pageTitleService = inject(PageTitleService);
  private downloadService = inject(DownloadService);

  items: any[] = [];
  isDisabled = false;
  readonly pageLimit = 300;
  readonly columnWidth = 11;
  currentPage = 0;
  showStart = 0;
  showEnd = this.columnWidth - 1;

  get pagedItems(): any[] {
    const begin = this.currentPage * this.pageLimit;
    return this.items.slice(begin, begin + this.pageLimit);
  }
  get totalPages(): number {
    return Math.ceil(this.items.length / this.pageLimit);
  }
  get shouldShowPager(): boolean {
    return this.totalPages > this.columnWidth;
  }

  pagerArr(): number[] {
    return Array.from({ length: this.totalPages }, (_, i) => i);
  }

  pagerClick(page: number, event?: Event): void {
    event?.preventDefault();
    const maxPage = Math.max(0, this.totalPages - 1);
    const num = Math.min(Math.max(Math.ceil(page), 0), maxPage);
    if (num + 1 <= Math.floor(this.columnWidth / 2)) {
      this.showStart = 0;
      this.showEnd = this.columnWidth - 1;
    } else if (num + 1 > this.totalPages - Math.floor(this.columnWidth / 2)) {
      this.showStart = Math.max(0, this.totalPages - this.columnWidth);
      this.showEnd = this.totalPages;
    } else {
      this.showStart = num - Math.floor(this.columnWidth / 2);
      this.showEnd = num + Math.floor(this.columnWidth / 2);
    }
    this.currentPage = num;
  }

  async ngOnInit(): Promise<void> {
    this.pageTitleService.set('ダウンロード管理', 'download', true);
    await this.loadList();
  }

  async loadList(): Promise<void> {
    this.isDisabled = true;
    try {
      this.items = await this.downloadService.getAll() ?? [];
      this.pagerClick(0);
    } finally {
      window.setTimeout(() => { this.isDisabled = false; }, 10000);
    }
  }

  async downloadFile(item: any): Promise<void> {
    const fileName = item.name || item.fileName;
    try {
      await this.downloadService.download(item.id, fileName);
    } finally {
      await this.loadList();
    }
  }
}
